import { render, staticRenderFns } from "./ExistingCustomer.vue?vue&type=template&id=2110c75f&scoped=true&"
import script from "./ExistingCustomer.vue?vue&type=script&lang=ts&"
export * from "./ExistingCustomer.vue?vue&type=script&lang=ts&"
import style0 from "./ExistingCustomer.vue?vue&type=style&index=0&id=2110c75f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2110c75f",
  null
  
)

export default component.exports